import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useStoreConfig } from "@/hooks/useProducts";
import { claimIcon } from "@/lib/claims";
import { formatEUR, formatShortEUR } from "@/lib/format";

export const ClaimList = ({ claims }) => (
  <ul className="grid gap-3 sm:grid-cols-2" data-testid="product-claims">
    {claims.map((c) => {
      const Icon = claimIcon(c);
      return (
        <li key={c} className="flex items-center gap-3 rounded-2xl border border-copper/20 bg-cream px-4 py-3 text-[16px] text-navy">
          <Icon className="h-5 w-5 shrink-0 text-copper" strokeWidth={1.5} />
          {c}
        </li>
      );
    })}
  </ul>
);

const Item = ({ value, title, children }) => (
  <AccordionItem value={value} className="border-copper/20">
    <AccordionTrigger data-testid={`product-accordion-${value}`} className="py-6 text-left font-display text-2xl font-medium text-navy hover:no-underline">
      {title}
    </AccordionTrigger>
    <AccordionContent className="pb-6 text-[17px] leading-relaxed text-slate2">{children}</AccordionContent>
  </AccordionItem>
);

export const ProductDetails = ({ product }) => {
  const { threshold, shippingCost } = useStoreConfig();
  return (
    <Accordion type="multiple" defaultValue={["silver"]} className="mt-12 border-t border-copper/20">
      <Item value="silver" title="Perché è pensato per la Silver Age">
        {product.story}
      </Item>
      <Item value="proprieta" title="Le proprietà">
        <ClaimList claims={product.claims} />
      </Item>
      <Item value="spedizione" title="Spedizione e pagamento">
        Spedizione in tutta Italia, gratuita per ordini da {formatShortEUR(threshold)} (altrimenti {formatEUR(shippingCost)}). Pagamento sicuro con carta tramite Stripe, senza registrazione.
      </Item>
    </Accordion>
  );
};
